<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref, onMounted} from "vue";
import { useUserStore } from "../../../store/users"
import { useModalStore } from "../../../store/modal"

const icon = computed(() => !user_deleted.value ? 'exclaim-default' : 'trashbin')
const heading = computed(() => !user_deleted.value ? `Are you sure you want to delete ${userStore.user?.first_name} ${userStore.user?.last_name}?` : `${userStore.user?.first_name} ${userStore.user?.last_name} deleted.`)
const subtext = computed(() => !user_deleted.value ? 'Any tickets currently assigned to this user will be unassigned.' : 'All tickets have been unassigned.')
const description = computed(() => !user_deleted.value ? `This action cannot be undone.` : null)
const error = ref(null)
const loading = ref(false)
const user_deleted = ref(false)
const userStore = useUserStore()
const modalStore = useModalStore()

const deleteUser = async () => {
    error.value = null
    loading.value = true
    try {
        await userStore.deleteUser(userStore.user.id)
        user_deleted.value = true
    }
    catch (err) {
        error.value = err.response?.data?.message ?? "Something went wrong. Please try again."
    } finally {
        loading.value = false
    }
}

onMounted(async () => {
    loading.value = true
    await userStore.getUser(modalStore.props.id)
    loading.value = false
})
</script>

<template>
    <default-modal-base :heading :description :subtext :icon :loading :refresh="user_deleted" :error class="--delete-modal">
        <div class="delete-modal-buttons-container">
            <brand-button v-if="!user_deleted" @click.prevent="deleteUser()">Yes, delete and unassign tickets</brand-button>
            <brand-button v-if="!user_deleted" variant="secondary" @click.prevent="modalStore.close()">Nevermind</brand-button>
            <brand-button v-if="user_deleted" variant="secondary" @click.prevent="modalStore.close(true)">Done</brand-button>
        </div>
    </default-modal-base>
</template>

<style lang="scss" scoped>
.delete-modal-buttons-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .brand-button {
        &.--primary {
            background: var(--color-secondary-orange);
        }
    }
}
</style>
